<template>
    <div v-if="app.isLoading" class="loading">
        Loading...
    </div>
    <div v-else>
        <slot />
    </div>
</template>

<script>
export default {
    props: ['app']
};
</script>
